import { apiUrl } from "../../utils/constants";
import { GET } from "../api.service.wrapper";

export const getDashboardData = async () => {
    return GET(apiUrl.web_dashboard);
}